(function () {
  function parseNum(v) {
    if (v == null) return NaN;
    return parseFloat(String(v).replace(",", "."));
  }

  function initCalculator(root) {
    if (root.__cbdCalcInit) return;
    root.__cbdCalcInit = true;

    const weightRange = root.querySelector("[data-weight-range]");
    const weightText  = root.querySelector("[data-weight-text]");
    const rateSelect  = root.querySelector("[data-rate-select]");
    const intensityBtns = Array.from(root.querySelectorAll("[data-intensity]"));
    const dropsEl = root.querySelector("[data-drops]");
    const mgEl    = root.querySelector("[data-mg]");

    if (!weightRange || !weightText || !rateSelect || !dropsEl || !mgEl) return;

    let coef = 0.5;

    function getMgPerDropRange() {
      const opt = rateSelect.options[rateSelect.selectedIndex];
      const min = parseNum(opt.getAttribute("data-mg-min"));
      const max = parseNum(opt.getAttribute("data-mg-max"));

      const safeMin = (isFinite(min) && min > 0) ? min : 5;
      const safeMax = (isFinite(max) && max > 0) ? max : safeMin;

      return { min: Math.min(safeMin, safeMax), max: Math.max(safeMin, safeMax) };
    }

    function update() {
      const weight = parseInt(weightRange.value, 10) || 60;
      weightText.textContent = String(weight);

      const mgPerDay = Math.round(weight * coef);
      const { min: mgMinPerDrop, max: mgMaxPerDrop } = getMgPerDropRange();

      let dropsMin = Math.ceil(mgPerDay / mgMaxPerDrop);
      let dropsMax = Math.ceil(mgPerDay / mgMinPerDrop);

      dropsMin = Math.max(1, dropsMin);
      dropsMax = Math.max(dropsMin, dropsMax);

      dropsEl.textContent = (dropsMin === dropsMax) ? String(dropsMin) : `${dropsMin} à ${dropsMax}`;
      mgEl.textContent = String(mgPerDay);
    }

    weightRange.addEventListener("input", update);
    rateSelect.addEventListener("change", update);

    intensityBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        intensityBtns.forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-pressed", "true");

        const nextCoef = parseNum(btn.getAttribute("data-coef"));
        coef = (isFinite(nextCoef) && nextCoef > 0) ? nextCoef : 0.5;

        update();
      });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll("[data-cbd-sim]").forEach(initCalculator);
  }

  // debug / hook
  window.CBDCalcInitAll = initAll;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches?.("[data-cbd-sim]") || n.querySelector?.("[data-cbd-sim]")) {
          initAll();
          return;
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
